import React from "react";

import AttendanceDashboard from "./component/AttendanceDashboard";
const Attendance = () => {
  return <AttendanceDashboard />;
};

export default Attendance;
